<template>
  <v-app id="empty">
    <v-main>
      <v-container fluid>
        
        <v-row cols="12">  
          <v-col cols="12" class="px-1"> <!-- Links -->
            <v-card class="ma-2">
              <v-card-title>Your Photo Assignments</v-card-title>
                <v-card-text>
                  <v-data-table 
                    :items="assignedHsfo" 
                    :search="search"
                    :fixed-header="fixedHeader" 
                    :headers="headers" 
                    :height="fixedHeader ? table_height : null"
                    :disable-pagination=true 
                    no-data-text="No assignments to display" 
                    :hide-default-footer="true" 
                  >
                  <template v-slot:top>
                    <v-text-field v-if="searchfield"
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search through all fields"
                    class="mx-4 searchfield"
                    ></v-text-field>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                    <td class="image-alignment">
                        <div class="image-borders" style="cursor: pointer;">
                            <v-img :src="props.item.photo" width="125px" height="100px"  @click="$router.open('/huis/onHsfoPhotographer/' + props.item.hsfo_encrid)"></v-img>
                        </div>
                    </td>
                    <td @click="$router.open('/huis/onHsfoPhotographer/' + props.item.hsfo_encrid)" class="td-markup">
                        <div><a> {{ props.item.huis_code }} </a></div>
                    </td>
                    <td>
                      <v-chip :color='statuscolor[props.item.hsfo_status]'>{{ props.item.hsfo_status }}</v-chip>
                    </td>
                    <td>
                        <v-chip :color='priocolor[props.item.hsfo_prio]'>{{ props.item.hsfo_prio }}</v-chip>
                    </td>
                    <td> {{ props.item.huis_postcode }}, {{ props.item.huis_adres }} , {{ props.item.huis_plaats }}</td>
                    <td>  
                      <v-chip class="ma-1" v-for="(hfot, hfotidx) in props.item.hfot" :key="hfotidx" :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_type }}</v-chip>

                    </td>
                    <td> {{ props.item.hsfo_deadline }} </td>
                    <td> {{ props.item.hsfo_inv_dat }} </td>
                    <td> {{ props.item.gebr_naam }} </td>
                    </tr> 
                  </template>
                </v-data-table>
              </v-card-text>
             </v-card>
          </v-col>
        </v-row>




        <v-row cols="12">  
          <v-col cols="12" class="px-1"> <!-- Links -->
            <v-card class="ma-2">
              <v-card-title>Available Photo Assignments</v-card-title>
                <v-card-text>
                  <v-data-table 
                    :items="availableHsfo" 
                    :search="search"
                    :fixed-header="fixedHeader" 
                    :headers="headers" 
                    :height="fixedHeader ? table_height : null"
                    :disable-pagination=true 
                    no-data-text="No new photo assignments available" 
                    :hide-default-footer="true" 
                  >
                  <template v-slot:top>
                    <v-text-field v-if="searchfield"
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label="Search through all fields"
                    class="mx-4 searchfield"
                    ></v-text-field>
                  </template>
                  <template v-slot:item="props">
                    <tr>
                    <td class="image-alignment">
                        <div class="image-borders" style="cursor: pointer;">
                            <v-img :src="props.item.photo" width="125px" height="100px"  @click="$router.open('/huis/onHsfoPhotographer/' + props.item.hsfo_encrid)"></v-img>
                        </div>
                    </td>
                    <td @click="$router.open('/huis/onHsfoPhotographer/' + props.item.hsfo_encrid)" class="td-markup">
                        <div><a> {{ props.item.huis_code }} </a></div>
                    </td>
                    <td>
                      <v-chip :color='statuscolor[props.item.hsfo_status]'>{{ props.item.hsfo_status }}</v-chip>
                    </td>
                    <td>
                        <v-chip :color='priocolor[props.item.hsfo_prio]'>{{ props.item.hsfo_prio }}</v-chip>
                    </td>
                    <td> {{ props.item.huis_postcode }}, {{ props.item.huis_adres }} , {{ props.item.huis_plaats }}</td>
                    <td>  
                      <v-chip class="ma-1" v-for="(hfot, hfotidx) in props.item.hfot" :key="hfotidx" :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_type }}</v-chip>

                    </td>
                    <td> {{ props.item.hsfo_deadline }} </td>
                    <td> {{ props.item.hsfo_inv_dat }} </td>
                    <td> {{ props.item.gebr_naam }} </td>
                    </tr> 
                  </template>
                </v-data-table>
              </v-card-text>
             </v-card>
          </v-col>
        </v-row>

       </v-container>
      </v-main>
      <navBar title="Ares - Main menu" type="photographer"/>
    </v-app>
  </template>

<script>
  import navBar from "@/components/ui/navbars/navbar.vue";
  export default {
    components: {
      navBar,
    },
    data() {
      return {
            localStorageItemStat: 'search.acco.statcodes',
            localStorageItemBedr: 'search.acco.bedrcodes',
            results: false,
            statCodesSelected: [],
            statCodes: [],
            plts_nrKeuzes: [],
            plts_nr: '',
            gebrCodesSelected: [],
            gebrCodes: [],
            bedrCodesSelected: [],
            bedrCodes: [],
            items: [],
            assignedHsfo: [],
            availableHsfo: [],
            huis_code: '',
            huis_naam: '',
            eign_naam: '',
            eign_email: '',
            partner_acco_id: '',
            param: {},
            searchCityInput: '',
            search: '',
            fixedHeader: true,
            headers: [
              { text: '', value: 'photo', sortable: false, align: 'start' },
              { text: 'Accommodation ID', value: 'huis_code', sortable: false, align: 'start' },
              { text: 'Status', value: 'hsfo_status', sortable: false, align: 'start' },
              { text: 'Priority', value: 'hsfo_prio', sortable: false, align: 'start' },
              { text: 'Acco Address', value: 'huis_adres', sortable: false, align: 'start' },
              { text: 'Tasks', value: 'tasks', sortable: false, align: 'start' },
              { text: 'Deadline', value: 'deadline', sortable: false, align: 'start' },
              { text: 'Date Request', value:'request_date'},
              { text: 'Rental Agent', value:'rental_agent'},
            ],
            table_height:'',
            searchfield: false,
            priocolor: {
              Low: '#D1E2FF',
              Medium: '#74EBE1',
              High: '#DC043B'
            },
            statuscolor: {
              Signedup: '#FAD2FC',
              Readytoshoot: '#FFEAB6',
              Offered: '#D1E2FF',
              Assigned: '#88DBFF',
              Completed: '#9AE095',
              Rejected: '#41454D',
              Onhold: '#FFB68E'
            },
            statuscolor_hfot: {
              Notapplicable: '#DC043B',
              Pending: '#D1E2FF',
              Completed: '#9AE095'
            }
        } 
    },
    methods: {
      
      updateData(data) {
        this[data.field] = data.value;
      },
      getHsfo() {
        this.results = true;
        this.$axios
        .post("ares/json/ares/huis/searchHsfoPhotographer.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHsfoPhotographer"
          },
          searchHsfoPhotographer: {

          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.assignedHsfo = res.data.searchHsfoPhotographer.assignedHsfo;
            this.availableHsfo = res.data.searchHsfoPhotographer.availableHsfo;
            if (res.data.color == "warning") {
              this.$store.dispatch('setSnackbar', {
                showing: true,
                text: res.data.text,
                color: res.data.color
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },
    mounted() {
      this.getHsfo()

    }
  }
</script> 
  